import { Aurelia } from "aurelia-framework";
import { PLATFORM } from "aurelia-pal";

import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/theme-fresh.css";
import "bootstrap/dist/js/bootstrap.min.js";

import "styles/kracht-bootstrap4.scss";

import { TCustomAttribute } from "aurelia-i18n";
import Backend from "i18next-http-backend";
import LngDetector from "i18next-browser-languagedetector";

import { CustomValidationRules } from "./validation/custom-validation-rules";
import { CustomValidationMessageProvider } from "./validation/custom-validation-message-provider";
import { IAuthConfig } from "./services/auth";
import { LocaleService } from "./services/locale-service";
import { HttpClientService } from "./services/http-client-service";

// polyfill to add ".key" property to KeyboardEvent
require("keyboardevent-key-polyfill").polyfill();

export async function configure(aurelia: Aurelia) {
  aurelia.use
    .standardConfiguration()
    .developmentLogging()
    .globalResources(PLATFORM.moduleName("converters/boolean"))
    .globalResources(PLATFORM.moduleName("converters/json"))
    .globalResources(PLATFORM.moduleName("converters/date"))
    .globalResources(PLATFORM.moduleName("converters/number"));

  aurelia.use.plugin(PLATFORM.moduleName("aurelia-i18n"), (instance: any) => {
    let aliases = ["t", "i18n"];
    TCustomAttribute.configureAliases(aliases);

    // register i18n plugins
    instance.i18next.use(Backend).use(LngDetector);

    return instance.setup({
      backend: {
        loadPath: HttpClientService.serviceBaseUrl + "/locale/texts/{{lng}}",
      },
      attributes: aliases,
      fallbackLng: "de",
      detection: {
        order: ["querystring", "cookie", "navigator"],
        lookupQuerystring: "lang",
        lookupCookie: "i18next",
        caches: ["cookie"],
      },
      debug: true,
      interpolation: {
        format: function (value: any, format: any, _: any) {
          if (typeof value === "number" && aurelia.container) {
            let localeService: LocaleService =
              aurelia.container.get(LocaleService);
            if (localeService) {
              return localeService.formatFloat(value, format);
            }
          }
          return value;
        },
      },
    });
  });

  // enable animation
  aurelia.use.plugin(PLATFORM.moduleName("aurelia-animator-css"));
  // if the css animator is enabled, add swap-order="after" to all router-view elements

  // use the validation plugin
  aurelia.use.plugin(PLATFORM.moduleName("aurelia-validation"));

  // aurelia dialogs plugin
  aurelia.use.plugin(PLATFORM.moduleName("aurelia-dialog"));

  // authentication plugin (custom)
  aurelia.use.feature(PLATFORM.moduleName("services/auth/index"), {
    tokenPrefix: "kracht",
    baseUrl: HttpClientService.basePath,
    loginUrl: HttpClientService.serviceBaseUrl + "/auth/login",
    changePasswordUrl:
      HttpClientService.serviceBaseUrl + "/auth/changepassword",
    authHeader: "X-Authorization",
  } as IAuthConfig);

  // use the ag-grid plugin for Aurelia
  aurelia.use.plugin(PLATFORM.moduleName("ag-grid-aurelia"));

  aurelia.start().then(() => {
    // setup custom message provider for validation messages, using I18N
    aurelia.container.get(CustomValidationMessageProvider).init();
    // define some custom validation rules
    aurelia.container.get(CustomValidationRules).init();
    // now set root application
    aurelia.setRoot(PLATFORM.moduleName("views/app"));
  });
}
